import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';
import '@fancyapps/fancybox';
import {animateInViewport} from "../transition";

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

$( '.image-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: false,
		prevNextButtons: false,
		contain: true,
		imagesLoaded: true,
		wrapAround: true,
		resize: true,
		draggable: false,
	} );

	var $previous = $this.parent().find( '.image-carousel-previous' );
	var $next = $this.parent().find( '.image-carousel-next' );

	$previous.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'previous' );
	} );

	$next.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'next' );
	} );
} );

$( '.card-carousel' ).each( function() {
	var $this = $( this );

	var cellCount = $this.attr( 'data-cell-count' );

	var $carousel = $this.flickity( {
		pageDots: (cellCount > 2),
		draggable: (cellCount > 2),
		prevNextButtons: false,
		contain: true,
		wrapAround: false,
		cellAlign: 'left',
	} );

	var flkty = $carousel.data( 'flickity' );
	var $previous = $this.parents( '.carousel-container' ).find( '.carousel-previous' );
	var $next = $this.parents( '.carousel-container' ).find( '.carousel-next' );

	$previous.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'previous' );
	} );

	$next.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'next' );
	} );

	flkty.on( 'change', function() {
		closePropertyInfo();
	} );

	if ( $this.attr( 'data-add-gaps' ) === 'true' ) {
		$this.find( '.flickity-page-dots .dot' ).each( function() {
			var $this = $( this );
			$this.after( '<li class="dot-gap"></li>' );
		} );
	}

	var $oneBeforeLastGap = $this.find( '.dot-gap' ).eq( -2 );
	$carousel.on( 'select.flickity', function( event, pointer ) {
		if ( flkty.selectedIndex == flkty.slides.length - 1 ) {
			$oneBeforeLastGap.addClass( 'active' );
		} else {
			$oneBeforeLastGap.removeClass( 'active' );
		}
	} );
} );

var $indexCarousel = $( '.index-carousel' ).flickity( {
	pageDots: false,
	prevNextButtons: false,
	wrapAround: true,
	contain: true,
	imagesLoaded: true,
} );

$( '[data-index]' ).on( 'mouseenter', function( event ) {
	var $this = $( this );
	var index = $this.attr( 'data-index' );

	if ( index ) {
		$indexCarousel.flickity( 'select', index );
		$( '.index-carousel .carousel-cell .active' ).removeClass( 'active' );

		$( '.carousel-cell-' + index ).find( '.move-up-in-viewport, .full-width-in-viewport' ).addClass( 'active' );
	}
} );

$( '.filter-carousel' ).each( function() {
	var $this = $( this );

	var adaptiveHeight = $this.hasClass( 'flickity-adaptive-height' );

	var $carousel = $this.flickity( {
		pageDots: false,
		prevNextButtons: false,
		contain: true,
		draggable: false,
		adaptiveHeight: adaptiveHeight,
		selectedAttraction: 0.015,
	} );

	var $nav = $this.parents( '.filter-carousel-container' ).find( '.filter-nav a' );

	$nav.on( 'click', function( clickEvent ) {
		var $this = $( this );

		var index = parseInt( $this.attr( 'data-index' ) );

		$carousel.flickity( 'selectCell', index );

		$nav.not( this ).removeClass( 'italic' ).addClass( 'inverted-link' );
		$this.addClass( 'italic' ).removeClass( 'inverted-link' );

		setTimeout( () => {
			animateInViewport();
		}, 100 );
	} );
} );

export var $dateCarousel = $( '.date-carousel' ).flickity( {
	pageDots: false,
	prevNextButtons: false,
	contain: true,
	draggable: false,
	selectedAttraction: 0.015,
} );

export function closePropertyInfo() {
	$( '.property-info' ).addClass( 'opacity-0 pointer-events-none' ).removeClass( '!h-3/4 py-10 py-5' );
	$( '.property-info-nav' ).removeClass( 'px-5' );
	$( '.property' ).find( 'a' ).removeClass( '!text-dyp-gronn' );
	$( '.property' ).removeClass( '!text-dyp-gronn' ).find( '.icon' ).removeClass( 'rotate-45' );
	$( '.property' ).find( '.label.close' ).addClass( 'hidden' );
	$( '.property' ).find( '.label.open' ).removeClass( 'hidden' );

	animateInViewport();
}
